export default "__VITE_ASSET__DuPBXcTg__"